module.exports = __webpack_public_path__ + "img/na.272478b8.png";